import $ from 'sitewide-jquery';

//This is *synchronous* by default
//
//properties is a Base64 encoded string (suitable
//for includion in a data-properties attribute
//on a DOM element) - *not* a JSON-like object
export function track_click(url, properties, async) {
  $.ajax({
    type: 'POST',
    url: '/out_link',
    data: {
      url: url,
      properties: properties,
    },
    async: !!async,
  });
}

export function loadClickTracking() {
  $(document).on('click', 'a.outlink', function () {
    const el = $(this);

    track_click(el.attr('href'), el.data('properties'), false);

    return true;
  });
}

export default { track_click, loadClickTracking };
